import type { DirectiveBinding } from 'vue'
import { useUserStore } from '@/stores/user'

const hasPermit = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // console.log('HasPermit', binding)

    const userStore = useUserStore()
    const has = userStore.hasPermission(binding.value)
    // console.log('hasPermit', has, binding.value)
    if (!has) {
      // console.log('hasPermit el.parentNode', el.parentNode)
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

export default hasPermit
